const swatches = document.querySelectorAll(".product__swathes .swatch__input");
const productImages = document.querySelectorAll(".product-single__media-slide");
var hasVariantIds = false;
var currentVariant = getParam('variant');
var isBundle = false;
var firstTimeUrl = document.URL;
if (document.getElementById("bundle-product")) {
    isBundle = true;
}

swatches.forEach(swatch => {
    swatch.addEventListener("click", (e) => {
        if(!isBundle && !hasVariantIds) {
            removeActive(productImages);
        }
        if(!hasVariantIds) {
            productImages.forEach(img => {
    			if(img.dataset.alt) {
    				let alts = img.dataset.alt.split(',');
        			if (alts && alts.includes(swatch.dataset.variantid)) {
        				img.classList.add('active');
        			}
      			}
            })
        }
    })
})


document.addEventListener('change', function() {
    var currentPageUrl = document.URL;
    var url = new URL(currentPageUrl);
    var variantId = url.searchParams.get('variant');
    currentPageUrl = variantId ? currentPageUrl :variantId;
	if(hasVariantIds && currentPageUrl && firstTimeUrl != currentPageUrl) {
		firstTimeUrl = currentPageUrl;
		if(variantId) {
			removeActive(productImages);
			productImages.forEach(img => {
				if(img.dataset.alt) {
					let alts = img.dataset.alt.split(',');
					if (alts && alts.includes(variantId)) {
						img.classList.add('active');
						currentVariant = variantId;
					}
                }
			});
		}
	}
});

window.addEventListener('load', () => {
    swatches.forEach(swatch => {
        if (swatch.checked == true) {
            productImages.forEach(img => {
				if(img.dataset.alt) {
					let alts = img.dataset.alt.split(',');
					if (alts) {
						if(alts.includes(swatch.dataset.variantid)) img.classList.add('active');
						if(alts.includes(currentVariant)) img.classList.add('active');
						alts.forEach((element) => {
                            let numberAlt = isNumber(element);
                            if(numberAlt) {
                                hasVariantIds = true;
                            }
                        });
					}
                }
            })
        }
    });
  
    if(isBundle) {
        setAllActive(productImages);
    }
})

function removeActive(array) {
    array.forEach(item => {
        item.classList.remove("active")
    })
}

function setAllActive(array) {
    array.forEach(item => {
        item.classList.add("active")
    })
}

function isNumber(value) {
   return !isNaN(parseFloat(value)) && isFinite(value);
}

function getParam(param){
  return new URLSearchParams(window.location.search).get(param);
}
